import Label from '~/src/atoms/Label';
import tw from 'twin.macro';
import useSelectedPack from './useSelectedPack';

const BrandName = ({ showBrand = true, ...rest }) => {
  const { brand = {} } = useSelectedPack();
  if (!showBrand) return <Label css={tw`h-4.5`} {...rest}></Label>;

  return (
    <Label css={tw`line-clamp-3 block text-md leading-md text-darkOnyx-100`} {...rest}>
      {brand?.name}
    </Label>
  );
};

export default BrandName;
